import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-34e4be74")

_pushScopeId("data-v-34e4be74")
const _hoisted_1 = { class: "testimonial-modal" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h4", null, "Baan:", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h4", null, "Arbeidsongeschikt door:", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("h4", null, "Besluit UWV:", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("h4", null, "Nieuw inkomen:", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Bereken uw inkomen ")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_ctx.testimonial !== null)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        title: _ctx.title,
        onClose: _cache[1] || (_cache[1] = $event => (_ctx.testimonial = null))
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("section", null, [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.testimonial.text.popup.job), 1 /* TEXT */)
            ]),
            _createVNode("section", null, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.testimonial.text.popup.reason), 1 /* TEXT */)
            ]),
            _createVNode("section", null, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.testimonial.text.popup.decision), 1 /* TEXT */)
            ]),
            _createVNode("section", null, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.testimonial.text.popup.income), 1 /* TEXT */)
            ]),
            _createVNode(_component_Button, {
              "icon-right": "chevron-right",
              onClick: _ctx.applyState
            }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["title"]))
    : _createCommentVNode("", true)
})